import { Box } from "@radix-ui/themes";
import { ReactNode } from "react";

interface ArticleContainerProps {
  children: ReactNode;
}

/**
 * ArticleContainer provides a consistent styling for all article components.
 * It uses a dark blue background with a subtle alpha effect to allow
 * the background imagery to be slightly visible through it.
 */
function ArticleContainer({ children }: ArticleContainerProps) {
  return (
    <Box
      style={{
        backgroundColor: "rgba(12, 16, 22, 0.82)", // Dark blue with 90% opacity
        padding: "20px",
        borderRadius: "6px", // Optional: adds rounded corners
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", // Optional: adds a subtle shadow
      }}
    >
      {children}
    </Box>
  );
}

export default ArticleContainer;
